/*! @pentacode/ui v0.1.0 */
import "./checkbox-B7K20jTx.js";
import { FormElement as e } from "./elements/formElement.js";
import "./icon-DW8BBY5W.js";
import "./popover-Ccsug15l.js";
import { t } from "./styledElement-DUAqv8gi.js";
import { t as n } from "./css-build-DcREbovZ.js";
import { t as r } from "./decorateMetadata-BXz2gmG4.js";
import { t as i } from "./decorate-C_HUHFGG.js";
import { LitElement as a, html as o, nothing as s } from "lit";
import { customElement as c, property as l, query as u, state as d } from "lit/decorators.js";
// \0lit-plugin:css-sheet:./src/elements/meals-input/meals-input.css.js
var f = n(":host{--_meals-input-spacing:var(--meals-input-spacing,.3em);--_meals-input-radius:var(--meals-input-radius,var(--radius-relative));--_meals-input-outline-color:var(--meals-input-outline-color,var(--primary));width:min-content;color:var(--meals-input-color,currentColor);cursor:pointer;border:solid 1px var(--meals-input-border-color,var(--shade-2));background:var(--meals-input-background,var(--color-bg));border-radius:var(--_meals-input-radius);outline:0 solid var(--_meals-input-outline-color);outline-offset:-1px;padding:var(--_meals-input-spacing);box-sizing:border-box;align-items:center;display:inline-flex}:host(:focus-within){outline-width:1px}:host([disabled]),:host(:disabled){opacity:var(--meals-input-opacity-disabled,.5);pointer-events:none}[part=trigger]{appearance:none;align-items:center;gap:var(--_meals-input-spacing);width:100%;color:inherit;font:inherit;cursor:inherit;white-space:nowrap;-webkit-user-select:none;user-select:none;background:0 0;border:0;margin:0;padding:0;line-height:1.5;display:flex}[part=trigger]:focus{outline:none}[part=trigger]>span{align-items:center;gap:.1em;display:inline-flex}[part=trigger] ptc-ui-icon{font-size:90%}[part=option]{appearance:none;border-radius:var(--_meals-input-radius);width:100%;color:inherit;font:inherit;text-align:start;cursor:pointer;white-space:nowrap;-webkit-user-select:none;user-select:none;background:0 0;border:0;align-items:center;gap:.5em;margin:0;padding:.4em .5em;display:flex}[part=option]:hover,[part=option]:focus-visible{background:var(--meals-input-option-background-hover,color-mix(in srgb, currentColor 10%, transparent))}[part=option]:focus-visible{outline:1px solid var(--_meals-input-outline-color);outline-offset:-1px}[part=option]>span{flex:1}[part=option]>ptc-ui-checkbox{pointer-events:none}@media print{:host{background:0 0;border:none}}"), p = class extends t(e(a)) {
	constructor(...e) {
		super(...e), this.styles = f, this.type = "meals", this.name = "", this.breakfast = !1, this.lunch = !1, this.dinner = !1, this.disabled = !1, this._formDisabled = !1;
	}
	static {
		this.shadowRootOptions = {
			...a.shadowRootOptions,
			delegatesFocus: !0
		};
	}
	focus(e) {
		this._trigger.focus(e);
	}
	blur() {
		this._trigger.blur();
	}
	get formValue() {
		let e = [];
		return this.breakfast && e.push("breakfast"), this.lunch && e.push("lunch"), this.dinner && e.push("dinner"), e.join(",");
	}
	formResetCallback() {
		this.breakfast = !1, this.lunch = !1, this.dinner = !1;
	}
	formDisabledCallback(e) {
		this._formDisabled = e;
	}
	connectedCallback() {
		super.connectedCallback(), this.internals.setFormValue(this.formValue);
	}
	updated(e) {
		super.updated(e), (e.has("breakfast") || e.has("lunch") || e.has("dinner")) && this.internals.setFormValue(this.formValue);
	}
	_toggle(e) {
		this[e] = !this[e], this.dispatchEvent(new CustomEvent("change", {
			composed: !0,
			bubbles: !0,
			detail: {
				breakfast: this.breakfast,
				lunch: this.lunch,
				dinner: this.dinner
			}
		}));
	}
	_renderOption(e, t) {
		return o`<button
            part="option"
            type="button"
            role="checkbox"
            aria-checked=${this[e]}
            @click=${() => this._toggle(e)}
        >
            <ptc-ui-icon name="icon.object.meal-${e}"></ptc-ui-icon>
            <span>${t}</span>
            <ptc-ui-checkbox inert .checked=${this[e]}></ptc-ui-checkbox>
        </button>`;
	}
	render() {
		let e = this.disabled || this._formDisabled;
		return o`
            <button
                part="trigger"
                id="trigger"
                type="button"
                ?disabled=${e}
                aria-label="
            Auslösetaste für Mahlzeiten"
            >
                ${this.breakfast ? o`<span><ptc-ui-icon name="icon.object.meal-breakfast"></ptc-ui-icon>1</span>` : s}
                ${this.lunch ? o`<span><ptc-ui-icon name="icon.object.meal-lunch"></ptc-ui-icon>1</span>` : s}
                ${this.dinner ? o`<span><ptc-ui-icon name="icon.object.meal-dinner"></ptc-ui-icon>1</span>` : s}
                ${!this.breakfast && !this.lunch && !this.dinner ? o`<span><ptc-ui-icon name="icon.object.meal"></ptc-ui-icon>0</span>` : s}
            </button>

            ${e ? s : o`<ptc-ui-popover part="popover" for="trigger" placement="bottom">
                      ${this._renderOption("breakfast", "Frühstück")} ${this._renderOption("lunch", "Mittagessen")}
                      ${this._renderOption("dinner", "Abendessen")}
                  </ptc-ui-popover>`}
        `;
	}
};
i([l({ reflect: !0 }), r("design:type", Object)], p.prototype, "name", void 0), i([l({
	type: Boolean,
	reflect: !0
}), r("design:type", Object)], p.prototype, "breakfast", void 0), i([l({
	type: Boolean,
	reflect: !0
}), r("design:type", Object)], p.prototype, "lunch", void 0), i([l({
	type: Boolean,
	reflect: !0
}), r("design:type", Object)], p.prototype, "dinner", void 0), i([l({
	type: Boolean,
	reflect: !0
}), r("design:type", Object)], p.prototype, "disabled", void 0), i([u("[part='trigger']"), r("design:type", typeof HTMLButtonElement > "u" ? Object : HTMLButtonElement)], p.prototype, "_trigger", void 0), i([d(), r("design:type", Object)], p.prototype, "_formDisabled", void 0), p = i([c("ptc-ui-meals-input")], p);
var m = p;
export { m as n, p as t };

//# sourceMappingURL=meals-input-DfAaRyin.js.map